(function() {
    var nameMeta = document.querySelector('meta[name="csrf-token-name"]');
    var valueMeta = document.querySelector('meta[name="csrf-token-value"]');
    var cookieMeta = document.querySelector('meta[name="csrf-cookie-name"]');
    var csrfName = nameMeta ? nameMeta.getAttribute('content') : (window.CSRF_TOKEN_NAME || '');
    var csrfValue = valueMeta ? valueMeta.getAttribute('content') : (window.CSRF_TOKEN_VALUE || '');
    var csrfCookieName = cookieMeta ? cookieMeta.getAttribute('content') : (window.CSRF_COOKIE_NAME || '');

    if (!csrfName || !csrfValue) {
        return;
    }

    window.CSRF_TOKEN_NAME = csrfName;
    window.CSRF_TOKEN_VALUE = csrfValue;
    if (csrfCookieName) {
        window.CSRF_COOKIE_NAME = csrfCookieName;
    }

    function readCookie(name) {
        if (!name) {
            return '';
        }
        var escaped = name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1');
        var match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : '';
    }

    function syncCsrfInputs(root) {
        if (!csrfName) {
            return;
        }
        var context = root && root.getElementsByName ? root : document;
        var inputs = context.getElementsByName(csrfName);
        if (!inputs || !inputs.length) {
            return;
        }
        for (var i = 0; i < inputs.length; i++) {
            var input = inputs[i];
            if (input && input.tagName && input.tagName.toLowerCase() === 'input') {
                input.value = csrfValue;
            }
        }
    }

    function ensureFormToken(form) {
        if (!form || !form.getElementsByName || !csrfName) {
            return;
        }
        var inputs = form.getElementsByName(csrfName);
        var input = null;
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i] && inputs[i].tagName && inputs[i].tagName.toLowerCase() === 'input') {
                input = inputs[i];
                break;
            }
        }
        if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = csrfName;
            form.appendChild(input);
        }
        input.value = csrfValue;
    }

    function refreshCsrfValue() {
        if (!csrfCookieName) {
            return;
        }
        var cookieValue = readCookie(csrfCookieName);
        if (cookieValue && cookieValue !== csrfValue) {
            csrfValue = cookieValue;
            window.CSRF_TOKEN_VALUE = cookieValue;
            if (valueMeta) {
                valueMeta.setAttribute('content', cookieValue);
            }
            syncCsrfInputs();
        }
    }

    function addTokenToFormData(formData) {
        if (formData && typeof formData.append === 'function') {
            if (typeof formData.has !== 'function' || !formData.has(csrfName)) {
                formData.append(csrfName, csrfValue);
            }
        }
    }

    function addTokenToDataString(data) {
        if (data.indexOf(csrfName + '=') === -1) {
            return (data ? data + '&' : '') + encodeURIComponent(csrfName) + '=' + encodeURIComponent(csrfValue);
        }
        return data;
    }

    var jqueryHooked = false;

    function setupJqueryPrefilter() {
        if (jqueryHooked) {
            return true;
        }
        if (!window.jQuery || !window.jQuery.ajaxPrefilter) {
            return false;
        }
        window.jQuery.ajaxPrefilter(function(options) {
            var method = (options.type || options.method || 'GET').toUpperCase();
            if (method === 'GET' || method === 'HEAD' || method === 'OPTIONS') {
                return;
            }

            refreshCsrfValue();

            if (typeof FormData !== 'undefined' && options.data instanceof FormData) {
                addTokenToFormData(options.data);
                return;
            }

            if (typeof options.data === 'string') {
                options.data = addTokenToDataString(options.data);
                return;
            }

            if (options.data && typeof options.data === 'object') {
                if (!Object.prototype.hasOwnProperty.call(options.data, csrfName)) {
                    options.data[csrfName] = csrfValue;
                }
                return;
            }

            options.data = encodeURIComponent(csrfName) + '=' + encodeURIComponent(csrfValue);
        });
        jqueryHooked = true;
        return true;
    }

    if (!setupJqueryPrefilter()) {
        var attempts = 0;
        var timer = setInterval(function() {
            attempts += 1;
            if (setupJqueryPrefilter() || attempts > 100) {
                clearInterval(timer);
            }
        }, 50);
    }

    document.addEventListener('submit', function(event) {
        var form = event.target;
        if (!form || !form.tagName || form.tagName.toLowerCase() !== 'form') {
            return;
        }
        refreshCsrfValue();
        ensureFormToken(form);
    }, true);

    if (!window.fetch) {
        return;
    }

    var originalFetch = window.fetch;
    window.fetch = function(input, init) {
        init = init || {};
        var method = (init.method || 'GET').toUpperCase();
        if (method === 'GET' || method === 'HEAD' || method === 'OPTIONS') {
            return originalFetch(input, init);
        }

        refreshCsrfValue();

        var url = '';
        if (typeof input === 'string') {
            url = input;
        } else if (input && input.url) {
            url = input.url;
        }

        if (url && url.indexOf('http') === 0 && url.indexOf(window.location.origin) !== 0) {
            return originalFetch(input, init);
        }

        var body = init.body;
        if (typeof FormData !== 'undefined' && body instanceof FormData) {
            addTokenToFormData(body);
            return originalFetch(input, init);
        }

        if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
            if (!body.has(csrfName)) {
                body.append(csrfName, csrfValue);
            }
            init.body = body;
            return originalFetch(input, init);
        }

        var headers = init.headers || {};
        var contentType = '';
        if (headers && typeof headers.get === 'function') {
            contentType = headers.get('Content-Type') || headers.get('content-type') || '';
        } else {
            contentType = headers['Content-Type'] || headers['content-type'] || '';
        }

        if (typeof body === 'string') {
            if (contentType.indexOf('application/x-www-form-urlencoded') !== -1) {
                init.body = addTokenToDataString(body);
            }
            return originalFetch(input, init);
        }

        if (!body) {
            if (typeof URLSearchParams !== 'undefined') {
                var params = new URLSearchParams();
                params.append(csrfName, csrfValue);
                init.body = params;
            } else {
                init.body = encodeURIComponent(csrfName) + '=' + encodeURIComponent(csrfValue);
            }
            if (headers && typeof headers.get === 'function') {
                if (!headers.has('Content-Type')) {
                    headers.set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                }
                init.headers = headers;
            } else {
                if (!headers['Content-Type'] && !headers['content-type']) {
                    headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
                }
                init.headers = headers;
            }
        }

        return originalFetch(input, init);
    };
})();
